import React, { useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  joinPostCardCampaignThunk,
  resetIsSavedDraftSuccess,
} from "@/features/campaigns/shared/store/campaignSlice";

import { GlobalContext, LoaderContext } from "@/helpers/contexts/contexts";
import { joinCampaignHelper } from "@/features/campaigns/shared/helpers/joinCampaignHelper";
import {
  campaignIsLoadingSelector as isLoadingCampaignsSelector,
  isSavedSelector,
} from "@/features/campaigns/shared/store/campaignSlice";
import JoinPostcardCampaignForm from "./joinPostcardCampaignForm";

type JoinMailSharkCampaignProps = {
  advanceSettingData?: Array<Record<string, any>>;
  campaign?: Record<string, any> | null;
  productList?: Array<Record<string, any>>;
};

function JoinMailSharkCampaign({
  campaign,
  productList,
  advanceSettingData,
}: JoinMailSharkCampaignProps) {
  const { campaignId } = useParams();
  const navigate = useNavigate();

  const { loggedInUser, selectedBrand } = useContext(GlobalContext);
  const loader = useContext(LoaderContext);

  const dispatch = useDispatch();
  const isSavedAsDraft = useSelector(isSavedSelector);
  const isLoading = useSelector(isLoadingCampaignsSelector);

  const [isDraft, setIsDraft] = useState(false);

  useEffect(() => {
    loader(isLoading);
  }, [isLoading, loader]);

  useEffect(() => {
    if (isSavedAsDraft) {
      dispatch(resetIsSavedDraftSuccess());

      if (isDraft) {
        navigate(`/launch-direct-mail`, {
          replace: true,
        });
      } else {
        navigate(`/participant/postcard-confirm`, {
          replace: true,
          state: { campaignId: campaignId, from: "join-campaign" },
        });
      }
    }
  }, [isSavedAsDraft, isDraft, dispatch, campaignId]);

  const getInitialValues = useMemo(() => {
    if (!campaign) return {};
    return joinCampaignHelper.getPostCardCampInitialValues(campaign);
  }, [campaign]);

  return (
    <JoinPostcardCampaignForm
      campaign={campaign}
      initialValues={getInitialValues}
      loggedInUser={loggedInUser}
      submit={(data: Record<string, any>) =>
        dispatch((joinPostCardCampaignThunk as any)(data))
      }
      setIsDraft={setIsDraft}
      selectedBrand={selectedBrand}
      productList={productList}
      getAdvanceSettingData={advanceSettingData}
      isDraft={isDraft}
    />
  );
}

export default JoinMailSharkCampaign;
